import React from "react";
import { CtaButton } from "./CtaButton";
import { painPoints } from "../data/content";
export function PainPoints() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-231" data-mp="2lmspkkrd14js">
      <div className="mx-auto max-w-4xl" data-id="element-232" data-mp="26yplxi0si4y5">
        <h2 className="text-center font-display text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-233" data-mp="26xwjuucs03mc">
          Do any of these sound <em className="text-plum-600" data-id="element-234" data-mp="2bv69aa060fa6">familiar?</em>
        </h2>
        <p className="mt-3 text-center text-[17px] text-ink/70" data-id="element-235" data-mp="1xw6jgz0x1ucf">
          If you answer <strong className="text-ink" data-id="element-236" data-mp="220e6mrrq728j">YES</strong> to any of them, this system was created for you.
        </p>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-237" data-mp="1o0va6w8a1fc2">
          {painPoints.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex items-start gap-4 rounded-2xl bg-plum-50 p-5" data-id="element-238" data-mp="1sywufkhfvkp4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-plum-700 shadow-sm" data-id="element-239" data-mp="3ie4du7e566me">
                <Icon className="h-5 w-5" aria-hidden data-id="element-240" data-mp="3nabmi7xx9w81" />
              </span>
              <p className="text-[16px] leading-snug text-ink/85" data-id="element-241" data-mp="1yyu7bbuwvzbo">{text}</p>
            </li>)}
        </ul>

        <div className="mt-12 rounded-3xl bg-plum-900 px-6 py-10 text-center text-white md:px-12" data-id="element-242" data-mp="1tzraufszz1fb">
          <p className="font-display text-[28px] font-extrabold leading-tight md:text-4xl" data-id="element-243" data-mp="27utesxeaagph">
            And it shouldn't have to be this way.
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-plum-100" data-id="element-244" data-mp="1g2lwztn1ky9i">
            Because the problem isn't necessarily a lack of knowledge.
          </p>
          <p className="mx-auto mt-3 max-w-2xl text-[17px] leading-relaxed text-white" data-id="element-245" data-mp="1p30m7434mxia">
            The problem may simply be that you've never had a system that tells you{" "}
            <strong className="text-gold" data-id="element-246" data-mp="30hnuzi42itx5">what to evaluate first</strong>,{" "}
            <strong className="text-gold" data-id="element-247" data-mp="30jqv4uyxq3fl">what to decide next</strong>, and{" "}
            <strong className="text-gold" data-id="element-248" data-mp="2vi1gl5ci77mr">what needs to be established before moving forward</strong>.
          </p>
        </div>

        <div className="mt-10" data-id="element-249" data-mp="1t7hnm7fqsi2o">
          <CtaButton label="I want a structured decision system" data-id="element-250" data-mp="1y3glclmyncfr" />
        </div>
      </div>
    </section>;
}